import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        title: ["Settings", "Настройки"][index],
    };
};
